import Toastify from "toastify-js";

const toastConfig = {
  close: false,
  gravity: "bottom",
  position: "right",
  stopOnFocus: true,
  className: "kensa-toast",
  style: {
    background: "transparent",
  },
};

const createToast = (options = {}) => {
  let type = options.type || "success";
  let message = options.message || "Hi!";
  let duration = options.duration || 1000;
  let url = options.url || null;

  if (type == "success") {
    Toastify({
      text: message,
      duration: duration,
      url: url,
      ...toastConfig,
      callback: function () {
        if (url === null) {
          location.reload();
        } else {
          window.location.href = url;
        }
      },
    }).showToast();
  } else {
    Toastify({ text: message, duration: duration, ...toastConfig }).showToast();
  }
};

export { createToast };
